import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import Resources from '@constants/resourses';
import { environment } from '@environments/environment';

import { LoginComponent } from '@shared/dialog/login/login.component';

import { SessionService } from '@services/session.service';
import { UtilityService } from '@services/utility.service';
import { TealiumUtagService } from '@services/utag.service';
import { AppService } from '@services/app.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  email: string;
  selectedQuote: any;
  isLoggedIn: boolean = false;

  tealiumData: any = {};

  constructor(
    public dialog: MatDialog,
    private utilityService: UtilityService,
    private sessionService: SessionService,
    private tealium: TealiumUtagService,
    private appService: AppService
  ) {
    this.isLoggedIn = this.utilityService.isLoggedIn();
    this.email = this.sessionService.getItemFromLocal(Resources.SessionStorageKeys.Email);
  }

  ngOnInit() {
    this.subscriptions.push(
      this.appService.getApplicationStatus().subscribe((data: any) => {
        if (data === 'update') {
          this.isLoggedIn = this.utilityService.isLoggedIn();
          this.email = this.sessionService.getItemFromLocal(Resources.SessionStorageKeys.Email);
          this.selectedQuote = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.SelectedQuote);
        }
      })
    );

    this.tealiumData = {
      // app variables
      app_name: environment.tealium_app_name,
      app_version: environment.tealium_app_version,
      app_platform: environment.tealium_app_platform,

      // page variables
      page_name: 'PostcodeEntry',
      page_type: 'RiskJourney',

      // Base URL
      base_url: window.location.href,
      energycomparison_subscribed: !!this.email,

      // user variables
      customer_id: !!this.email ? this.utilityService.encryptIntoSha256(this.email.toLowerCase().trim()) : undefined,
    }
  }

  // onClick CompareTheMarket logo [TEAM] - Check with team regarding this functionality
  logo(): void {
    // Check if the environment is production
    if (environment.ENV === 'PROD') {
      // If it is, clear session storage and redirect to the production URL
      // this.sessionService.clearSessionStorage();
      window.open('https://comparethemarket.com/', '_self');
    } else {
      // Otherwise, clear session storage, remove quotes data from local storage, and redirect to the home URL
      // this.sessionService.clearSessionStorage();
      this.sessionService.removeItemFromLocal(Resources.SessionStorageKeys.QuotesData);
      window.open(environment.home_url, '_self');
    }
  }

  // onClick signIn and signOut buttons
  sign(state: boolean): void {
    // If the state is true, call the signOut method
    if (state) {
      this.signOut();
    } else {
      // Otherwise, call the signIn method
      this.signIn();
    }
  }

  // signIn method
  signIn(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      data: { placement: 'header_sign_in', target: 'login' },
      width: '570px',
      maxWidth: window.innerWidth <= 767 ? '95vw' : '569px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'ctm-modal'
    });

    // After the dialog is closed, check the result
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        // Closed loggedIn popup
        this.isLoggedIn = this.utilityService.isLoggedIn();
        this.email = this.sessionService.getItemFromLocal(Resources.SessionStorageKeys.Email);
        this.selectedQuote = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.SelectedQuote);

        // // From postcode page
        // if (window.location.pathname === '/') {
        //   this.tealiumData['page_name'] = 'PostcodeEntry';
        //   this.tealiumData['page_type'] = 'RiskJourney';

        //   delete this.tealiumData['energy_supplier_switching_to'];
        //   delete this.tealiumData['energy_electricitytariff_switching_to'];
        //   delete this.tealiumData['energy_gastariff_switching_to'];
        // } else if (window.location.pathname === '/information') {
        //   // From information page
        //   this.tealiumData['page_name'] = 'YourEnergyDashboard';
        //   this.tealiumData['page_type'] = 'RiskJourney';

        //   delete this.tealiumData['energy_supplier_switching_to'];
        //   delete this.tealiumData['energy_electricitytariff_switching_to'];
        //   delete this.tealiumData['energy_gastariff_switching_to'];
        // } else if (window.location.pathname === '/energy-result') {
        //   // From quote page
        //   this.tealiumData['page_name'] = 'YourTariffs';
        //   this.tealiumData['page_type'] = 'EnquiryPresentation';

        //   delete this.tealiumData['energy_supplier_switching_to'];
        //   delete this.tealiumData['energy_electricitytariff_switching_to'];
        //   delete this.tealiumData['energy_gastariff_switching_to'];
        // } else if (window.location.pathname === '/switch/user-details') {
        //   // Application page
        //   this.tealiumData['page_name'] = 'SwitchApplication';
        //   this.tealiumData['page_type'] = 'PaymentPage';
        //   this.tealiumData['energy_supplier_switching_to'] = this.selectedQuote.SupplierName;
        //   this.tealiumData['energy_electricitytariff_switching_to'] = this.selectedQuote?.TariffName;
        //   this.tealiumData['energy_gastariff_switching_to'] = this.selectedQuote?.TariffName;
        // } else if (window.location.pathname === '/switch/confirmation') {
        //   // Switch confirmation page
        //   this.tealiumData['page_name'] = 'SwitchRequestConfirmed';
        //   this.tealiumData['page_type'] = 'PaymentPage';

        //   delete this.tealiumData['energy_supplier_switching_to'];
        //   delete this.tealiumData['energy_electricitytariff_switching_to'];
        //   delete this.tealiumData['energy_gastariff_switching_to'];
        // }

        // delete this.tealiumData['enquirySubject'];
        // delete this.tealiumData['encodedEmail'];
        // this.tealiumData['customer_id'] = (!!this.email) ? this.utilityService.encryptIntoSha256(this.email.toLowerCase().trim()) : undefined;
        // this.tealiumData['base_url'] = window.location.href;
        // this.tealiumData['energycomparison_subscribed'] = !!this.email;

        // // Trigger view event
        // this.tealium.viewEvent(this.tealiumData);
      }
    });
  }

  // signOut method
  signOut(): void {
    this.isLoggedIn = false;
    // Call the signingOut method from the utility service
    this.utilityService.signingOut();
    // Reset the application status to initial state
    this.appService.resetApplicationStatus();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
